<div class="page-header">
  <div class="title-section">
    <h2 class="page-title">Fiche client</h2>
    <p class="page-subtitle">Mettez à jour les informations du client</p>
  </div>
  <a routerLink="/clients" class="btn btn-outline btn-with-icon back-link">
    <mat-icon aria-hidden="true">arrow_back</mat-icon>
    Retour à la liste
  </a>
</div>

<div class="form-container">
  @if (loadingClient()) {
    <div class="loading-state">
      Chargement des données du client...
    </div>
  } @else {
    <div class="card shadow-sm">
      <div class="card-tabs">
        <button type="button" class="tab-btn" [class.active]="activeTab() === 'info'" (click)="setTab('info')">
          Informations du client
        </button>
        <button type="button" class="tab-btn" [class.active]="activeTab() === 'contacts'" (click)="setTab('contacts')">
          Contacts ({{ selectedContacts().length }})
        </button>
      </div>

      <form [formGroup]="clientForm" (ngSubmit)="onSubmit()" class="modern-form">
        <div [hidden]="activeTab() !== 'info'">
          <div class="form-section">
            <h3 class="section-title">Informations du client</h3>
            <div class="form-row">
              <div class="form-group col">
                <label for="numeroClient">NUMÉRO CLIENT</label>
                <input type="text" id="numeroClient" formControlName="numeroClient" class="form-control" placeholder="ex: CLI-2024-001">
              </div>
              <div class="form-group col">
                <label for="siret">SIRET</label>
                <input type="text" id="siret" formControlName="siret" class="form-control" placeholder="14 chiffres">
                @if (clientForm.get('siret')?.touched && clientForm.get('siret')?.errors?.['siret']) {
                  <div class="field-error">Le SIRET doit contenir exactement 14 chiffres.</div>
                }
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col">
                <label for="denomination">DÉNOMINATION / NOM</label>
                <input type="text" id="denomination" formControlName="denomination" class="form-control" placeholder="ex: Entreprise SARL">
              </div>
            </div>
          </div>

          <div class="form-section">
            <h3 class="section-title">Adresse de facturation</h3>
            <div class="form-row">
              <div class="form-group col">
                <label for="adresseFacturation">ADRESSE</label>
                <input type="text" id="adresseFacturation" formControlName="adresseFacturation" class="form-control" placeholder="Rue, avenue...">
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col">
                <label for="codePostal">CODE POSTAL</label>
                <input type="text" id="codePostal" formControlName="codePostal" class="form-control" placeholder="ex: 75001">
                @if (clientForm.get('codePostal')?.touched && clientForm.get('codePostal')?.errors?.['codePostal']) {
                  <div class="field-error">Le code postal doit contenir exactement 5 chiffres.</div>
                }
              </div>
              <div class="form-group col">
                <label for="ville">VILLE</label>
                <input type="text" id="ville" formControlName="ville" class="form-control" placeholder="ex: Paris">
              </div>
            </div>
          </div>

          <div class="form-section">
            <h3 class="section-title">Photo du client</h3>
            <div class="form-group">
              <div class="drop-zone"
                   [class.drag-over]="isDragOver()"
                   (dragover)="onDragOver($event)"
                   (dragleave)="onDragLeave($event)"
                   (drop)="onDrop($event)"
                   (click)="fileInput.click()">

                @if (!previewDataUrl() && !currentPhotoUrl()) {
                  <div class="drop-zone__content">
                    <mat-icon class="drop-zone__icon" aria-hidden="true">photo_camera</mat-icon>
                    <div class="drop-zone__text">
                      Glissez-déposez une photo ici ou cliquez pour sélectionner un fichier
                    </div>
                    <div class="drop-zone__hint">PNG, JPG jusqu'à ~5 Mo</div>
                  </div>
                } @else if (previewDataUrl()) {
                  <div class="preview">
                    <img [src]="previewDataUrl()" alt="Nouvelle photo" />
                    <div class="preview-actions">
                      <span class="badge badge-new">Nouvelle photo</span>
                      <button type="button" class="btn btn-outline btn-sm" (click)="removeSelectedFile(); $event.stopPropagation();">Retirer</button>
                    </div>
                  </div>
                } @else {
                  <div class="preview">
                    <img [src]="currentPhotoUrl()" alt="Photo actuelle" />
                    <div class="preview-actions">
                      <span class="badge">Photo actuelle</span>
                      <div class="drop-zone__hint">Glissez ou cliquez pour changer</div>
                    </div>
                  </div>
                }
              </div>
              <input #fileInput type="file" (change)="onFileSelected($event)" accept="image/*" class="hidden-input">
              <p class="help-text">Cliquez ou glissez une image pour modifier la photo.</p>
            </div>
          </div>
        </div>

        <div [hidden]="activeTab() !== 'contacts'">
          <div class="form-section">
            <h3 class="section-title">Contacts associés</h3>
            <p class="section-subtitle">Gérez les contacts pour ce client</p>

            <div class="contacts-selection">
              <div class="search-box-container">
                <button type="button" class="btn btn-secondary btn-sm btn-with-icon" (click)="toggleContactSearch()">
                  <mat-icon aria-hidden="true">{{ showContactSearch() ? 'close' : 'search' }}</mat-icon>
                  {{ showContactSearch() ? 'Fermer la recherche' : 'Ajouter un contact' }}
                </button>

                @if (showContactSearch()) {
                  <div class="contact-search-dropdown card shadow-sm">
                    <div class="search-input-wrapper">
                      <input type="text"
                             class="form-control"
                             placeholder="Rechercher par nom, prénom, email..."
                             (input)="onSearchContact($event)"
                             autofocus>
                    </div>
                    <div class="search-results">
                      @for (contact of contactSearchResults(); track contact.id) {
                        <div class="search-result-item" (click)="addContact(contact)">
                          <div class="contact-info">
                            <span class="contact-name">{{ contact.prenom }} {{ contact.nom }}</span>
                            <span class="contact-email">{{ contact.email }}</span>
                          </div>
                          <span class="add-icon">+</span>
                        </div>
                      } @empty {
                        <div class="no-results">Aucun contact trouvé</div>
                      }
                    </div>
                  </div>
                }
              </div>

              <div class="selected-contacts-list">
                @for (contact of selectedContacts(); track contact.id) {
                  <div class="contact-card">
                    <div class="contact-details">
                      <strong>{{ contact.prenom }} {{ contact.nom }}</strong>
                      <div class="contact-meta">
                        <span><mat-icon aria-hidden="true">phone</mat-icon> {{ contact.telephone || 'Non renseigné' }}</span>
                        <span><mat-icon aria-hidden="true">mail</mat-icon> {{ contact.email }}</span>
                      </div>
                    </div>
                    <button type="button" class="btn-remove" (click)="removeContact(contact.id)" title="Retirer ce contact">
                      &times;
                    </button>
                  </div>
                } @empty {
                  <div class="empty-selection">
                    <p>Aucun contact associé pour le moment.</p>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>

        @if (errorMessage()) {
          <div class="error-banner">{{ errorMessage() }}</div>
        }

        <div class="form-actions">
          <div class="form-actions-left">
             <button type="button"
                     *ngIf="!isArchived()"
                     [disabled]="isLoading()"
                     (click)="onDeleteClick()"
                     class="btn btn-danger">
               {{ canDelete() ? 'Supprimer' : 'Archiver' }}
             </button>
          </div>
          <div class="form-actions-right">
            <button type="button" routerLink="/clients" class="btn btn-outline">Annuler</button>
            <button type="submit" [disabled]="clientForm.invalid || isLoading()" class="btn btn-primary">
              {{ isLoading() ? 'Mise à jour...' : 'Mettre à jour le client' }}
            </button>
          </div>
        </div>
      </form>
    </div>
  }
</div>

<app-confirm-dialog
  *ngIf="showDeleteModal()"
  [title]="canDelete() ? 'Supprimer le client' : 'Archiver le client'"
  [message]="canDelete()
    ? 'Êtes-vous sûr de vouloir supprimer définitivement le client ' + clientDenomination() + ' ?'
    : 'Ce client est lié à des affaires et ne peut pas être supprimé. Voulez-vous l\'archiver à la place ?'"
  (confirmed)="confirmDelete()"
  (cancelled)="cancelDelete()"
></app-confirm-dialog>
